// L'avvio di un'attività «con un input»: si scrive il testo che chiede (es. cosa cercare) e parte.
import { useState } from 'react';
import type { Routine } from '../../lib/api';
import { Button } from '../../components/Button';
import { Field, TextArea } from '../../components/Field';
import { Modal } from '../../components/Modal';

export function RunWithInput({
  routine,
  onClose,
  onRun,
}: {
  routine: Routine;
  onClose: () => void;
  onRun: (input: string) => void;
}) {
  const [text, setText] = useState('');
  const footer = (
    <>
      <Button variant="secondary" onClick={onClose}>
        Annulla
      </Button>
      <Button
        variant="primary"
        icon="play"
        disabled={!text.trim()}
        onClick={() => {
          onRun(text.trim());
          onClose();
        }}
      >
        Avvia
      </Button>
    </>
  );
  return (
    <Modal title={routine.name} width={520} onClose={onClose} footer={footer}>
      <div className="t-small dim">{routine.task}</div>
      <Field label={routine.inputHint || 'Input'}>
        <TextArea value={text} onChange={setText} rows={3} autoFocus />
      </Field>
    </Modal>
  );
}
